import { Stack } from '@mui/material';
import { v4 } from 'uuid';

import { AccordionWithHeading, EmailCell, GesellschaftCell, Tablelike } from '../../../components/general';
import { capabilities, type ThemaFromThemaRouter, type Veranstaltung } from '../../../dtos';
import { getExperteName } from '../../../utils';
import { BlockungenTextStack } from '../BlockungenTextStack';
import { UpdateRessourcenBlockungen } from '../UpdateRessourcenBlockungen';
import { content } from './TerminExperteCard.content';
import { printEmail } from './TerminExperteCard.utils';

type TerminExperteCardProps = {
  readonly veranstaltung: Veranstaltung;
  readonly thema: ThemaFromThemaRouter;
};

export const TerminExperteCard = ({ veranstaltung, thema }: TerminExperteCardProps) => {
  const canEditExperte = veranstaltung.capabilities.includes(capabilities.EDIT_EXPERTE);

  return (
    <AccordionWithHeading heading={content.heading}>
      <Stack spacing={1}>
        {canEditExperte && (
          <UpdateRessourcenBlockungen veranstaltung={veranstaltung} thema={thema} editType="experte" />
        )}
        {veranstaltung.experteBlockungen.map((experteBlockung) => (
          <Tablelike
            key={experteBlockung.experteSapId}
            withDivider
            rows={[
              [content.fields.name, <b key={v4()}>{getExperteName(experteBlockung.experte)}</b>],
              [content.fields.rolle, content.noInfoAvailable],
              [content.fields.sapId, experteBlockung.experteSapId],
              [content.fields.zeitraum, <BlockungenTextStack key={v4()} zeitraeume={experteBlockung.zeitraeume} />],
              [
                content.fields.gesellschaft,
                <GesellschaftCell key={v4()} gesellschaft={experteBlockung.experte.gesellschaft} />,
              ],
              [content.fields.email, <EmailCell key={v4()} email={printEmail(experteBlockung)} />],
            ]}
          />
        ))}
      </Stack>
    </AccordionWithHeading>
  );
};
